module.exports = __webpack_public_path__ + "img/space.2730949b.png";